import { Flex } from '@chakra-ui/react';
import { useMemo } from 'react';
import { SlimTag } from '@texas/api/endpoints/tagsApi';
import { TagWithTooltip } from '../TagWithTooltip';
import { TagFilterOption, useTagFilter } from './TagFilterContext';
import { useActiveSession } from '@texas/hooks/useSession';

interface FilteredTagsCellProps {
  tags: SlimTag[];
}

export function FilteredTagsCell({ tags }: FilteredTagsCellProps) {
  const { filterOption } = useTagFilter();
  const session = useActiveSession();
  const currentUserId = session.currentUser.id;

  const filteredTags = useMemo(() => {
    switch (filterOption) {
      case TagFilterOption.MyTags:
        return tags.filter(
          (tag) => tag.userId === currentUserId || tag.userId === null,
        );
      case TagFilterOption.All:
      default:
        return tags;
    }
  }, [tags, filterOption, currentUserId]);

  if (filteredTags.length === 0) {
    return null;
  }

  return (
    <Flex gap={1} flexWrap="wrap">
      {filteredTags.map((tag) => (
        <TagWithTooltip key={tag.id} tag={tag} />
      ))}
    </Flex>
  );
}
